<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Customer Balance Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_date: moment(new Date()).format("YYYY-MM-DD"),
      totals:{
        totalin:0,
        totalout:0,
      },
      filterRecords:{
        id: atob(this.$route.params.id),
        datefrom: atob(this.$route.params.datefrom),
        dateto: atob(this.$route.params.dateto),
      },
    };
  },
  computed: {
    ...mapGetters("customers", [
        "CustomerBalanceDetails"
    ]),
  },
  methods: {
    ...mapActions({
        FetchBalanceDetails: "customers/fetchCustomerBalanceDetails",
    }),
  },

  watch: {
    CustomerBalanceDetails(newValue){
      if(newValue == true){
        this.FetchBalanceDetails(this.filterRecords);
      }
    }
  },

  updated() {
    let total_in = 0;
        let total_out = 0;
        if(this.CustomerBalanceDetails){
          this.CustomerBalanceDetails.forEach((item)=>{
              total_in = total_in+parseInt(item.amount);
          });
          this.totals.totalin = total_in;
          this.CustomerBalanceDetails.forEach((item)=>{
              total_out = total_out+parseInt(item.amountOut);
          });
          this.totals.totalout = total_out;

          setTimeout(() => {
              window.onafterprint = window.close;
              window.print();
              window.history.back();
          }, 2000)
        }
  },
  created() {
    this.FetchBalanceDetails(this.filterRecords);
  },
};
</script>

<style scoped>
/* .print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
} */
</style>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="bg-white p-2">
          <div class="print-font" style="padding-left: 15px">            
            <table width="100%" class="mt-3">
                <b-spinner
                    v-if="!CustomerBalanceDetails"
                    class="m-0"
                    variant="primary"
                    role="status"
                ></b-spinner>
                <tr v-else>
                <td width="100%" style="text-align: right; padding-right: 15px !important">
                  <center>
                    <img v-if="CustomerBalanceDetails[0].business2.Businesslogo" :src="CustomerBalanceDetails?CustomerBalanceDetails[0].business2.Businesslogo:''" height="80" /> 
                    <strong style="font-size: 25px; text-transform: uppercase">
                    {{
                      CustomerBalanceDetails ? CustomerBalanceDetails[0].business2.name : "---"
                    }}</strong
                  >
                  <p style="font-size: 22px;">
                    <span>
                      <strong>Location: </strong>
                      {{
                        CustomerBalanceDetails ? CustomerBalanceDetails[0].business2.address : "---"
                      }}</span
                    >
                    <br />
                    <strong>Tel: </strong
                    >{{
                      CustomerBalanceDetails
                        ? "+256" + CustomerBalanceDetails[0].business2.phone1
                        : "---"
                    }}
                    <br />
                    <strong>Email: </strong
                    >{{ CustomerBalanceDetails ? CustomerBalanceDetails[0].business2.email : "---" }}
                  </p>
                  </center>
                </td>
              </tr>
            </table>
            <hr style="border-style: dashed; width: 97%" />
            <h5
              style="
                text-align: center;
                font-size: 22px;
                font-weight: bold;
                font-family: Courier New, Courier, Lucida Sans Typewriter,
                  Lucida Typewriter, monospace;
              "
            >
              <span>
                <strong v-if="filterRecords.datefrom == 'null'">
                  CUSTOMER LEDGER FOR {{ CustomerBalanceDetails[0].customer.name.toUpperCase() }} - {{ CustomerBalanceDetails[0].customer.contact }}<br/>
                  AS OF {{ current_date }}
                </strong>
                <strong v-else>
                  CUSTOMER LEDGER FOR {{ CustomerBalanceDetails[0].customer.name.toUpperCase() }} - {{ CustomerBalanceDetails[0].customer.contact }}<br/>
                  FROM {{ filterRecords.datefrom }} TO {{ filterRecords.dateto }}
                </strong>
              </span>
              <br />
            </h5>
            <center>
              <table width="100%" class="table" style="font-size: 15px">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Date</th>
                    <th>Category</th>
                    <th>Received Via</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, r) in CustomerBalanceDetails" :key="r">
                    <td>{{ r + 1 }}</td>
                    <td>{{ record.date }}</td>
                    <td>{{ record.Category }}</td>
                    <td>{{ record.mode }}</td>
                    <td>{{ record.amountOut.toLocaleString() }}</td>
                    <td>{{ record.amount.toLocaleString() }}</td>
                    <td>{{ record.newbalance }}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b>Total Debit: </b></td>
                    <td></td>
                    <td><b>{{totals.totalout?(totals.totalout).toLocaleString():0}}</b></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b>Total Credit: </b></td>
                    <td></td>
                    <td><b>{{totals.totalin?(totals.totalin).toLocaleString():0}}</b></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b>Total Balance: </b></td>
                    <td></td>
                    <td><b>{{(totals.totalout - totals.totalin)?(totals.totalout - totals.totalin).toLocaleString():0}}</b></td>
                  </tr>
                </tbody>
              </table>
            </center>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>